export function quotationServiceError(products = []) {
  const families = new Set(products.map(row => row.product || row.type)
    .filter(name => ['Délégation', 'Gestion', 'Placement', 'Vacation'].includes(name))
    .map(name => ['Délégation', 'Gestion'].includes(name) ? 'Intérim' : name));
  return families.size > 1 ? 'Délégation et gestion peuvent partager un devis. Le placement et la vacation nécessitent chacun un devis séparé, avec leurs propres CGV.' : '';
}
